<div class="flex flex-row items-center justify-end">
    <fa-icon
        class="text-gray-200 text-base mr-1"
        data-testid="paginator-first-page"
        size="sm"
        [class.active]="currentPage() > 1"
        [icon]="['fas', 'chevron-double-left']"
        (click)="setCurrentPage(1)" />
    <fa-icon
        class="text-gray-200 text-base"
        data-testid="paginator-previous-page"
        size="sm"
        [class.active]="currentPage() > 1"
        [icon]="['fas', 'chevron-left']"
        (click)="previousPage()" />
    <span
        class="mx-4 text-sm"
        data-testid="paginator-page-number"
        >{{ currentPage() }}{{ totalPages() ? `/${totalPages()}` : '' }}</span
    >
    <fa-icon
        class="text-gray-200 text-base"
        data-testid="paginator-next-page"
        size="sm"
        [class.active]="currentPage() < totalPages()"
        [icon]="['fas', 'chevron-right']"
        (click)="nextPage()" />
    <fa-icon
        class="text-gray-200 text-base ml-1"
        data-testid="paginator-last-page"
        size="sm"
        [class.active]="currentPage() < totalPages()"
        [icon]="['fas', 'chevron-double-right']"
        (click)="setCurrentPage(totalPages())" />
</div>
